import { useState, useEffect } from 'react'
import {
  Box,
  Avatar,
  Button,
  List,
  ListItem,
  IconButton,
  Typography,
  Paper,
} from '@mui/material'
import { useDropzone } from 'react-dropzone'
import { toast } from 'react-toastify'

const FileUploader = ({
  title= "File",
  maxFiles = 2,
  maxSize = 2 * 1024 * 1024, // 2MB
  acceptedFileTypes = { 'image/*': ['.png', '.jpg', '.jpeg', '.gif'] },
  onChange = () => {},
  onUpload = files => {},
}) => {
  const [files, setFiles] = useState([])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    maxFiles,
    maxSize,
    accept: acceptedFileTypes,
    onDrop: acceptedFiles => {
      setFiles(acceptedFiles.map(file => Object.assign(file)))
    },
    onDropRejected: () => {
      toast.error(`You can only upload ${maxFiles} files & max size ${maxSize / 1024 / 1024} MB.`, {
        autoClose: 3000,
      })
    },
  })

  useEffect(() => {
    onChange(files)
  }, [files])

  const renderFilePreview = file => {
    return file.type.startsWith('image') ? (
      <img width={38} height={38} alt={file.name} src={URL.createObjectURL(file)} />
    ) : (
      <i className="ri-file-text-line" />
    )
  }

  const handleRemoveFile = file => {
    setFiles(files.filter(f => f.name !== file.name))
  }

  const handleRemoveAllFiles = () => {
    setFiles([])
  }

  const handleUpload = () => {
    onUpload(files)
  }

  return (
    <Paper elevation={0} sx={{ p: 4, borderRadius: 2, border: '1px solid #eee', m: 1 }}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        
      </Typography>

      <Box
        {...getRootProps()}
        sx={{
          border: '2px dashed #ccc',
          borderRadius: 2,
          px: 6,
          py: 8,
          textAlign: 'center',
          cursor: 'pointer',
          backgroundColor: isDragActive ? '#f5f5f5' : '#fafafa',
          transition: 'background-color 0.3s ease',
        }}
      >
        <input {...getInputProps()} />
        <Avatar variant="rounded" sx={{ width: 48, height: 48, mb: 2, backgroundColor: '#f2f2f2' }}>
          <i className="ri-upload-2-line" style={{ fontSize: '1.5rem' }} />
        </Avatar>
        <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
          {title}
        </Typography>
        <Typography color="text.secondary" fontSize={13}>
          Allowed {Object.values(acceptedFileTypes).flat().join(', ')} Max {maxFiles} files and max size of {maxSize / 1024 / 1024} MB
        </Typography>
        <Typography color="text.secondary" fontSize={13}>
          
        </Typography>
      </Box>

      {files.length > 0 && (
        <>
          <List sx={{ mt: 4 }}>
            {files.map(file => (
              <ListItem key={file.name} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box display="flex" alignItems="center" gap={2}>
                  {renderFilePreview(file)}
                  <Box>
                    <Typography>{file.name}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {(file.size / 1024).toFixed(1)} KB
                    </Typography>
                  </Box>
                </Box>
                <IconButton onClick={() => handleRemoveFile(file)}>
                  <i className="ri-close-line text-xl" />
                </IconButton>
              </ListItem>
            ))}
          </List>

          <Box mt={2} display="flex" gap={2}>
            <Button color="error" variant="outlined" onClick={handleRemoveAllFiles}>
              Remove All
            </Button>
            <Button variant="contained" onClick={handleUpload}>
              Upload Files
            </Button>
          </Box>
        </>
      )}
    </Paper>
  )
}

export default FileUploader



{/* <FileUploader
  maxFiles={5}
  maxSize={3 * 1024 * 1024}
  acceptedFileTypes={{ 'image/*': ['.png', '.jpg'], 'application/pdf': ['.pdf'] }}
  onUpload={handleUpload}
  onChange={handleChange}
/> */}